import React from 'react';
import { NavLink } from 'react-router-dom';
import Collapsible from 'react-collapsible';

import Styles from '../../containers/Organization/styles';
import Label from '../../components/UIKit/Label';

const OrganizationsMenuItem = ({ organization, isActive }) => {
  const { key, name } = organization;

  return (
    <Collapsible
      key={organization.key}
      trigger={(
        <Label style={Styles.organization}>
          { name }
        </Label>
      )}
      open={isActive}
    >
      <NavLink
        style={Styles.link}
        activeStyle={Styles.activeLink}
        to={`/organizations/${key}/members`}
      >
        Members
      </NavLink>
      <NavLink
        style={Styles.link}
        activeStyle={Styles.activeLink}
        to={`/organizations/${key}/details`}
      >
        Edit Organization
      </NavLink>
    </Collapsible>
  );
};

export default OrganizationsMenuItem;



// WEBPACK FOOTER //
// ./src/components/OrganizationsMenuItem/OrganizationsMenuItem.jsx